enum UploadProductAssetDialogVariant {
  Hero = 'hero',
  Carousel = 'carousel',
}

export { UploadProductAssetDialogVariant };
